import React, { cloneElement, Children } from 'react';

import { Grid } from 'components/grid/Grid';
import s from './PartnersGrid.scss';

interface IProps {
  heading?: string;
  children: React.ReactNode;
  columns?: 2 | 3 | undefined;
}

export const PartnersGrid = ({ heading, children, columns = 3 }: IProps) => {
  if (!children) {
    return null;
  }

  return (
    <div className={s.partnersGrid}>
      {heading && <h3 className={s.partnersGrid__heading}>{heading}</h3>}
      <div className={s.partnersGrid__content}>
        <Grid columns={columns} isColumnLayout={true} limitColumns={false}>
          {Children.map(children, (child, i) => {
            return (
              <div key={i} className={s.partnersGrid__item}>
                {cloneElement(child as React.ReactElement<any>, {
                  index: i,
                })}
              </div>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};
